import { Component, inject } from '@angular/core';
import { BaseAppMComponent } from '../../base-components/base-app-m.component';
import { GlobalsService } from '../../services/globals.service';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';

import { InventoryService } from '../../services/inventory.service';
import { CRUDActions } from '../../enums/CRUDActions';
import { InventoryTypeBus } from '../../models/InventoryTypeBus';
import { ManufacturerType } from './manufacturer-type.interface';

@Component({
    selector: 'manufacturer-type-dialog',
    templateUrl: './manufacturer-type-dialog.component.html',
    styleUrls: ['./manufacturer-type-dialog.component.scss']
})
export class ManufacturerTypeDialogComponent extends BaseAppMComponent<InventoryTypeBus, InventoryService, null, null> {

    svc_data = inject(InventoryService)

    active = false
    selectData: any[] = []
    selectedName = ''
    selectedId = '';
    cancelText = 'Cancel'
    displaySelect = true
    displayInput = false
    duplicateError = false;

    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, qry_rd: DQOIReferenceDataQuery) {
        super(globals, featureFlagService, qry_rd)
    }

    show() {
        this.getManufacturerTypes()
        this.active = true
        this.displaySelect = true
    }

    onChanges() {
        this.duplicateError = false;
        const duplicate = this.selectData.find(s => s.manufacturerTypeName.toLowerCase() === this.selectedName.toLowerCase() && this.selectedId != s.manufacturerTypeId);
        if (duplicate) {
            this.duplicateError = true
        }
    }

    onSelect(selectedValue: any) {
        this.cancelText = 'Return'
        this.displaySelect = false
        this.displayInput = true
        this.selectedName = selectedValue.manufacturerTypeName
        this.selectedId = selectedValue.manufacturerTypeId
    }

    getManufacturerTypes() {
        this.svc_data.getManufacturerTypes().subscribe({
            next: (results: any) => {
                results.resultList.sort((a: any, b: any) => {
                    const nameA = a.manufacturerTypeName.toUpperCase()
                    const nameB = b.manufacturerTypeName.toUpperCase()
                    if (nameA < nameB) {
                      return -1;
                    }
                    if (nameA > nameB) {
                      return 1;
                    }
                    return 0;
                })
                this.selectData = results.resultList
            },
            error: (error) => { console.log('getManufacturerTypes error', error) }
        })
    }

    save() {
        const duplicate = this.selectData.find(s => s.manufacturerTypeName.toLowerCase() === this.selectedName.toLowerCase() && this.selectedId != s.manufacturerTypeId)

        if (duplicate) {
            this.cnfShow("This manufacturer type already exists.", CRUDActions.None, null, "Duplicate Manufacturer Type", "DUP_manufacturerTypeName", false)
            return
        }

        let body: ManufacturerType = {
            manufacturerTypeName: this.selectedName,
            manufacturerTypeId: this.selectedId
        }

        this.svc_data.saveManufacturerType(body).subscribe({
            next: () => {
                this.show()
                this.displayInput = false
                this.cancelText = 'Cancel'
            },
            error: (error) => { console.log('saveManufacturerType error', error) }
        })
    }

    new() {
        this.cancelText = 'Return'
        this.selectedName = ''
        this.selectedId = ''
        this.displaySelect = false
        this.displayInput = true
        this.duplicateError = false
    }

    cancel() {
        this.selectedName = ''
        this.displaySelect = true
        this.displayInput = false
        this.duplicateError = false
        if (this.cancelText === 'Cancel') {
            this.close()
        } else {
            this.cancelText = 'Cancel'
        }
    }

    close() {
        this.active = false;
        this.selectedName = ''
        this.selectedId = ''
        this.displaySelect = false
        this.displayInput = false
        this.duplicateError = false
    }
}
